import { FormControl, InputLabel } from '@material-ui/core';
import React from 'react';

import { currencyFormat } from 'utils/currencyFormat';
import { red } from 'utils/color-styles';
import Budget from 'entities/budget/model';
import { BUDGET_LOW_PERCENTAGE, BudgetTotals } from 'containers/DonationRulesListPage/utils';

interface Props {
  budget: Budget;
  budgetTotals: BudgetTotals;
  budgetInactive: boolean;
  matchingBalanceLow: boolean;
}

export const DonationGivingRulesDonationMatchingSummary = ({
  budget,
  budgetTotals,
  budgetInactive,
  matchingBalanceLow = Number.isFinite(budgetTotals.matchingBalance) &&
    !budgetInactive &&
    budgetTotals.matchingBalance / budgetTotals.totalMatchingLimit < BUDGET_LOW_PERCENTAGE,
}: Props): JSX.Element => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 15,
      opacity: budgetInactive ? 0.5 : 1,
    }}
  >
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Matching Used</InputLabel>
      </FormControl>
      <div>{currencyFormat(budgetTotals.totalMatched, budget.get('currencyCode'))}</div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Matching Balance</InputLabel>
      </FormControl>
      <div style={{ color: matchingBalanceLow ? red : undefined }}>
        {Number.isFinite(budgetTotals.matchingBalance)
          ? currencyFormat(budgetTotals.matchingBalance, budget.get('currencyCode'))
          : '-'}
      </div>
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Matching Limit</InputLabel>
      </FormControl>
      <div>
        {Number.isFinite(budgetTotals.totalMatchingLimit)
          ? currencyFormat(budgetTotals.totalMatchingLimit, budget.get('currencyCode'))
          : '-'}
      </div>
    </div>
    <div style={{ width: '20%' }}>
      {budget.get('limitAssertionType') === 'Contribution' && (
        <>
          <FormControl style={{ width: '100%', height: 17 }}>
            <InputLabel shrink>Contributions Matched</InputLabel>
          </FormControl>
          <div>{currencyFormat(budgetTotals.totalContribution, budget.get('currencyCode'))}</div>
        </>
      )}
    </div>
    <div style={{ width: '20%' }}>
      <FormControl style={{ width: '100%', height: 17 }}>
        <InputLabel shrink>Donations Matched</InputLabel>
      </FormControl>
      <div>{budgetTotals.donationsMatchedCount}</div>
    </div>
  </div>
);

export default DonationGivingRulesDonationMatchingSummary;
